import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=4df4e907&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=4df4e907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df4e907",
  null
  
)

export default component.exports